import React, { useEffect, useRef, useState } from "react";

/**
 * แสดงวิดีโอ HTML5 พร้อมหน้าปก
 * - poster: URL รูปภาพ (แนะนำ)
 * - posterTime: วินาทีในคลิปที่ต้องการใช้เป็นหน้าปก (ใช้เมื่อไม่มี poster)
 */
const VideoWithPoster = ({
  src,
  poster = null,
  posterTime = null,
  title = "วิดีโอ",
  ...props
}) => {
  const videoRef = useRef(null);
  const [resolvedPoster, setResolvedPoster] = useState(poster);

  useEffect(() => {
    setResolvedPoster(poster);
  }, [poster]);

  useEffect(() => {
    if (poster || posterTime == null || posterTime < 0) {
      return undefined;
    }

    let cancelled = false;
    const video = document.createElement("video");
    video.crossOrigin = "anonymous";
    video.muted = true;
    video.playsInline = true;
    video.preload = "auto";
    video.src = src;

    const captureFrame = () => {
      if (cancelled || !video.videoWidth || !video.videoHeight) {
        return;
      }

      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const context = canvas.getContext("2d");
      context.drawImage(video, 0, 0, canvas.width, canvas.height);

      try {
        const dataUrl = canvas.toDataURL("image/jpeg", 0.85);
        if (!cancelled) {
          setResolvedPoster(dataUrl);
        }
      } catch {
        // อาจเกิด CORS ถ้าวิดีโออยู่คนละ origin — ใช้รูป poster แทน
      }
    };

    const handleLoadedMetadata = () => {
      const duration = Number.isFinite(video.duration) ? video.duration : 0;
      const seekTime = duration > 0 ? Math.min(posterTime, duration - 0.1) : posterTime;
      video.currentTime = Math.max(0, seekTime);
    };

    video.addEventListener("loadedmetadata", handleLoadedMetadata);
    video.addEventListener("seeked", captureFrame);

    return () => {
      cancelled = true;
      video.removeEventListener("loadedmetadata", handleLoadedMetadata);
      video.removeEventListener("seeked", captureFrame);
      video.src = "";
      video.load();
    };
  }, [src, poster, posterTime]);

  return (
    <video
      ref={videoRef}
      src={src}
      poster={resolvedPoster || undefined}
      controls
      preload="metadata"
      playsInline
      title={title}
      style={{
        width: "100%",
        height: "100%",
        display: "block",
        objectFit: "cover",
        backgroundColor: "#000",
      }}
      {...props}
      autoPlay={false}
    />
  );
};

export default VideoWithPoster;
